import { render } from "./AdminConfig.vue?vue&type=template&id=41def3c2&scoped=true"
import script from "./AdminConfig.vue?vue&type=script&lang=js"
export * from "./AdminConfig.vue?vue&type=script&lang=js"

import "./AdminConfig.vue?vue&type=style&index=0&id=41def3c2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41def3c2"]])

export default __exports__